"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var hasWidth = function (widths) {
    return Object.keys(widths).reduce(function (acc, cur) { return acc || widths[cur]; }, false);
};
var getWidth = function (width, gridColumns) {
    if (typeof width !== 'number')
        return undefined;
    var normalizedWidth = Math.max(0, Math.min(gridColumns, width));
    return "".concat((100 / gridColumns) * normalizedWidth, "%");
};
exports.default = (function (_a) {
    var _b = _a.forceWidth, forceWidth = _b === void 0 ? undefined : _b, width = _a.width, _c = _a.offset, offset = _c === void 0 ? {} : _c, _d = _a.pull, pull = _d === void 0 ? {} : _d, _e = _a.push, push = _e === void 0 ? {} : _e, screenClass = _a.screenClass, gutterWidth = _a.gutterWidth, gridColumns = _a.gridColumns;
    var styles = {
        boxSizing: 'border-box',
        minHeight: 1,
        position: 'relative',
        paddingLeft: gutterWidth / 2,
        paddingRight: gutterWidth / 2,
        width: '100%',
    };
    styles.flexBasis = '100%';
    styles.flexGrow = 0;
    styles.flexShrink = 0;
    styles.maxWidth = '100%';
    styles.marginLeft = '0%';
    styles.right = 'auto';
    styles.left = 'auto';
    utils_1.screenClasses.forEach(function (s, index) {
        var size = s;
        if (utils_1.screenClasses.indexOf(screenClass) >= index) {
            var currentWidth = getWidth(width[size], gridColumns);
            var isSizedToContent = width[size] === 'content';
            styles.flexBasis = isSizedToContent ? 'auto' : currentWidth || styles.flexBasis;
            styles.width = styles.flexBasis;
            styles.maxWidth = currentWidth || styles.maxWidth;
            styles.marginLeft = getWidth(offset[size], gridColumns) || styles.marginLeft;
            styles.right = getWidth(pull[size], gridColumns) || styles.right;
            styles.left = getWidth(push[size], gridColumns) || styles.left;
        }
    });
    if (!hasWidth(width)) {
        styles.flexBasis = 0;
        styles.flexGrow = 1;
    }
    if (forceWidth) {
        styles.flexBasis = 'unset';
        styles.flexGrow = 'unset';
        styles.flexShrink = 'unset';
        styles.width = forceWidth;
    }
    return __assign({}, styles);
});
//# sourceMappingURL=style.js.map